import { inject, Injectable, Injector } from '@angular/core';

import { BaasAppState, BaasI18n, BaasSecurityLevel, resolveValue } from '@lvflanders/bar';
import { BarActionDef, BarCoreService } from '@lvflanders/bar-ng';

import { BAR_LAYOUT_CONSTANTS } from './bar-layout.constants';
import { BarLayoutState } from './bar-layout-state.contract';

@Injectable()
export class BarDefaultLayoutState implements BarLayoutState {
    readonly #appState = inject(BaasAppState);
    readonly #injector = inject(Injector);
    readonly #i18n = inject(BaasI18n);
    get #core() {
        return this.#injector.get(BarCoreService);
    }

    homeUrl: string = undefined;

    get rootUrl(): string {
        return (this.#core.rootAction != null ? this.#getUrlFromActionDef(this.#core.rootAction) : null) || this.#appState.location?.app?.url;
    }
    get environment(): string {
        return this.#getSecLevelString(this.#appState.toepassing.securityLevel);
    }

    get documentTitle(): string {
        return this.#appState.basiscontext == null || this.#appState.basiscontext.zone == 'E'
            ? this.#i18n.get('DOMAIN_BAR_LAYOUT.TITLE')
            : this.#appState.toepassing.naam;
    }

    get favIconUrl(): string {
        return this.#appState.location.baasStatic.url + BAR_LAYOUT_CONSTANTS.IMAGES.FAVICON;
    }

    get appVersion(): string {
        return this.#appState.toepassing.versie;
    }

    #getUrlFromActionDef(action: BarActionDef): string {
        let result: string = null;

        // here we decide what's the url based on the definition
        if (action.href != null) {
            result = resolveValue(action.href);
        } else if (action.routerUrl != null) {
            result = resolveValue(action.routerUrl);
        } else if (action.routerCommands != null) {
            result = resolveValue(action.routerCommands).join('/');
        }

        return result;
    }
    #getSecLevelString(securityLevel: BaasSecurityLevel): string {
        switch (securityLevel) {
            case BaasSecurityLevel.Development:
                return 'DEV';
            case BaasSecurityLevel.Test:
                return 'TST';
            case BaasSecurityLevel.Production:
                return 'PRD';
            default:
                return 'Unknown';
        }
    }
}
